import { EventEmitter, Injectable } from '@angular/core';
import {take} from 'rxjs/operators';

declare const firstAccessNativeIntegration;

declare global {
    interface Window {
        getFirstAccessData: (data: any) => any;
        webkit: any;
        JSBridge: any;
    }
}

@Injectable({ providedIn: 'root' })
export class CacheNativeFistAccessService {
    private EmmitChange = new EventEmitter<{ data }>();
    private reg: RegExp = new RegExp('(error|Error|erro|Erro)|(400|500|404|406)');

    constructor() {

        window.getFirstAccessData = (data: string) => {
            this.EmmitChange.emit({ data });
        };

    }

    getItemCommunicator<T>(): Promise<T> {

        if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.firstAccessNativeIntegration) {
            this.comunicationIOS();
        } else {
            this.comunicationAndroid();
        }

        return new Promise((resolve, reject) => {
            this.EmmitChange
            .pipe(take(1))
            .subscribe(value => {
                if (value.data) {
                    if (this.reg.test(value.data)) {
                        reject(value.data);
                    }
                }
                resolve(value.data);
            });
        });
    }

    private comunicationIOS() {
        const value = JSON.stringify({'param': 'GET'});
        window.webkit.messageHandlers.firstAccessNativeIntegration.postMessage(value);
    }

    private comunicationAndroid() {
        try {
            const paramsValue = JSON.stringify({'param': 'GET'});
            firstAccessNativeIntegration.postMessage(paramsValue);
        } catch (error) {
        }
    }

}

